import React from 'react';
import Card from './Card';

const QuestionCard = ({base_url}) => {
  const fields = ['material_id', 'difficulty', 'skill', 'type', 'question', 'answers', 'correct_answers'];
  const endpoint = `${base_url}/questions`;
  return <Card endpoint={endpoint} fields={fields} />;
};

export default QuestionCard;